import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import {
  LayoutDashboard,
  Activity,
  Shield,
  Zap,
  Bot,
  Headphones,
} from 'lucide-react'

gsap.registerPlugin(ScrollTrigger)

const benefits = [
  /* {
    icon: LayoutDashboard,
    title: 'Gestión Integral',
    description:
      'Centraliza todos los procesos académicos, administrativos y financieros en una única plataforma conectada. Elimina la fragmentación de datos.',
  }, */
  {
    icon: LayoutDashboard,
    title: 'Gestión Integral',
    description:
      'Centraliza todos los procesos académicos y administrativos en una única plataforma conectada. Elimina la fragmentación de datos.',
  },
  {
    icon: Activity,
    title: 'Acceso en Tiempo Real',
    description:
      'Información actualizada al instante para directivos, docentes, estudiantes y padres de familia. Toma decisiones con datos, no con intuición.',
  },
  {
    icon: Shield,
    title: 'Escalable y Seguro',
    description:
      'Crece con tu colegio. Desde 100 hasta 50,000 estudiantes. Certificaciones de seguridad y respaldo automático en la nube.',
  },
  {
    icon: Zap,
    title: 'Interfaz Intuitiva',
    description:
      'Diseñada para usuarios de cualquier nivel técnico. Menos curva de aprendizaje, mayor adopción por parte de tu equipo docente.',
  },
  /* {
    icon: Bot,
    title: 'Automatización Inteligente',
    description:
      'Automatiza reportes, recordatorios de pagos, seguimiento académico y comunicaciones. Ahorra hasta 20 horas semanales de trabajo administrativo.',
  }, */
  {
    icon: Bot,
    title: 'Automatización Inteligente',
    description:
      'Automatiza reportes, seguimiento académico y comunicaciones. Ahorra hasta 20 horas semanales de trabajo administrativo.',
  },
  {
    icon: Headphones,
    title: 'Soporte Dedicado',
    description:
      'Equipo de soporte especializado en educación. Respuesta promedio de 15 minutos. Acompañamiento durante toda la implementación.',
  },
]

const Benefits = () => {
  const sectionRef = useRef(null)
  const headerRef = useRef(null)
  const cardsRef = useRef(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        headerRef.current.children,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: headerRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      )

      gsap.fromTo(
        cardsRef.current.children,
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.12,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: cardsRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      )
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (
    <section
      id="beneficios"
      ref={sectionRef}
      className="section-padding"
      style={{ backgroundColor: '#F0FDF4' }}
    >
      <div className="container-main">
        <div ref={headerRef} className="text-center mb-16">
          <span
            className="badge-pill"
            style={{
              backgroundColor: 'rgba(16,185,129,0.1)',
              color: '#10B981',
              fontSize: '12px',
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}
          >
            ¿POR QUÉ OLAN ACADEMIC?
          </span>
          <h2
            className="mt-4 text-3xl md:text-[42px] font-bold"
            style={{ color: '#0F293E', lineHeight: 1.2 }}
          >
            Impulsa el{' '}
            <span style={{ color: '#10B981' }}>Éxito</span> de tu Colegio
          </h2>
          <p
            className="mt-4 text-lg mx-auto"
            style={{
              color: '#4B5563',
              lineHeight: 1.6,
              maxWidth: 640,
            }}
          >
            Nuestra plataforma está diseñada para resolver los desafíos reales de
            las instituciones educativas modernas.
          </p>
        </div>

        <div
          ref={cardsRef}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="group bg-white rounded-2xl p-8 md:p-10 transition-all duration-300 hover:-translate-y-1"
              style={{
                border: '1px solid #E5E7EB',
                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'rgba(16,185,129,0.3)'
                e.currentTarget.style.boxShadow = '0 10px 25px -5px rgba(0,0,0,0.1)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#E5E7EB'
                e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0,0,0,0.1)'
              }}
            >
              <div
                className="flex items-center justify-center rounded-full"
                style={{
                  width: 56,
                  height: 56,
                  backgroundColor: 'rgba(16,185,129,0.1)',
                }}
              >
                <benefit.icon size={28} color="#10B981" strokeWidth={2} />
              </div>
              <h3
                className="mt-6 text-xl font-semibold"
                style={{ color: '#0F293E' }}
              >
                {benefit.title}
              </h3>
              <p
                className="mt-3 text-[15px] leading-relaxed"
                style={{ color: '#4B5563', lineHeight: 1.6 }}
              >
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Benefits
